// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_TravelHealthV1BerlinDirektDe = z.object({
  born_on: z.string().min(1),
  tariff_type: z.enum(['single', 'family']),
  insured_family_members: z
    .array(
      z.object({
        born_on: z
          .union([z.number(), z.string(), z.date()])
          .pipe(z.coerce.date())
          .transform((value) => {
            return format(value, constants.SERVER_DATE_FORMAT)
          }),
        last_name: z.string().min(1).optional(),
        first_name: z.string().min(1).optional(),
        relationship_type: z.enum(['child', 'partner', 'spouse']),
      })
    )
    .max(7)
    .optional(),
})

const Schema_TravelHealthV1BerlinDirektDe = BaseSchema_TravelHealthV1BerlinDirektDe.superRefine(
  (values, ctx) => {
    if (values['tariff_type'] !== undefined && ['family'].includes(values['tariff_type'])) {
      if (values['insured_family_members'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'array',
          received: 'undefined',
          message: 'Required',
          path: ['insured_family_members'],
        })
      }
    }
  }
)

export default Schema_TravelHealthV1BerlinDirektDe
